export default __webpack_public_path__ + "static/media/Imagesources_result_01.7682504b.png";